/**
 * Design System Close Button Component
 * Unique close button used by modal surfaces across the site.
 */
import React from 'react';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface DSCloseButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'light' | 'dark';
}

export const DSCloseButton = React.forwardRef<HTMLButtonElement, DSCloseButtonProps>(
  ({ variant = 'light', className, 'aria-label': ariaLabel = 'Fermer', type = 'button', ...props }, ref) => {
    const variantClasses = {
      light: 'border-gray-200 bg-white text-gray-600 hover:text-gray-900 hover:border-gray-400 hover:bg-gray-50',
      dark: 'border-gray-700 bg-gray-800 text-gray-400 hover:text-white hover:border-gray-500 hover:bg-gray-700',
    };

    return (
      <button
        ref={ref}
        type={type}
        aria-label={ariaLabel}
        className={cn(
          'absolute right-4 top-4 z-50 flex h-11 min-h-11 w-11 min-w-11 shrink-0 aspect-square items-center justify-center rounded-full border p-0 leading-none transition-colors disabled:pointer-events-none',
          variantClasses[variant],
          className,
        )}
        {...props}
      >
        <X className="h-4 w-4" />
        <span className="sr-only">{ariaLabel}</span>
      </button>
    );
  },
);

DSCloseButton.displayName = 'DSCloseButton';
